<template>
  <Modal>
    <Modal.Title>Confirm cancellation</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        {{ cancelContent.confirmBody }}
      </p>

      <div class="mt-4 flex items-start gap-2">
        <Checkbox v-model="agreed" class="mt-px shrink-0" />
        <p
          class="cursor-pointer text-[12px] leading-[17px] text-gray-500"
          @click="agreed = !agreed"
        >
          I acknowledge my continued acceptance of the
          <a href="/legal/terms" target="_blank" class="text-link" @click.stop
            >Dacr Terms</a
          >,
          <a href="/legal/privacy" target="_blank" class="text-link" @click.stop
            >Privacy Policy</a
          >, and
          <a
            href="/legal/payments"
            target="_blank"
            class="text-link"
            @click.stop
            >Payments Policy</a
          >.
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button
        variant="danger"
        :size="isMobile ? 'lg' : 'md'"
        :disabled="!agreed"
        :loading="submitting"
        @click="submit"
      >
        Agree, cancel subscription
      </Button>
      <Button
        variant="stroke"
        :size="isMobile ? 'lg' : 'md'"
        :disabled="submitting"
        @click="handleKeep"
      >
        Keep subscription
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal, Button, Checkbox } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import { closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'

import { cancelContent } from './content'
import { useCancelPlan } from './useCancelPlan'

const { isMobile } = useDevice()
const { submitting, submit } = useCancelPlan()

const agreed = ref(false)

const handleKeep = () => {
  closeAllModals()
  closeAllSheets()
}
</script>
